import { Container, Nav, Navbar, Row, Col } from "react-bootstrap";
import classNames from "classnames";
import { isLoggedIn, loginRedirect } from "../../../services/AuthService";
import Menu from "./Menu";
import ProfileDropdown from "./ProfileDropdown";
import MemberContext from "../../../utils/MemberContext";
import { useContext, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

// Menu data
import { profileOptions } from "./data";

// images
import fourS_logo from "../../../assets/images/Web_4S Logo.png";
import hkjc_logo from "../../../assets/images/Web_HKJC_Logo.png";

const hkjc_link = "https://www.charities.hkjc.com";

const Navbar4 = ({ isSticky, navClass, buttonClass, fixedWidth }) => {
  const [isLogin, setIsLogin] = useState(isLoggedIn());
  const { member } = useContext(MemberContext);

  // on scroll add navbar class
  useEffect(() => {
    const btnTop = document.getElementById("btn-back-to-top");
    const navbar = document.getElementById("sticky");
    window.addEventListener("scroll", (e) => {
      e.preventDefault();
      if (btnTop) {
        if (
          document.body.scrollTop >= 50 ||
          document.documentElement.scrollTop >= 50
        ) {
          btnTop.classList.add("show");
        } else {
          btnTop.classList.remove("show");
        }
      }
      if (navbar) {
        if (
          document.body.scrollTop >= 240 ||
          document.documentElement.scrollTop >= 240
        ) {
          navbar.classList.add("navbar-sticky");
        } else {
          navbar.classList.remove("navbar-sticky");
        }
      }
    });

    setIsLogin(isLoggedIn());
  }, []);

  useEffect(() => {
    setIsLogin(isLoggedIn());
  }, [member]);

  const handleLogin = () => {
    loginRedirect(window.location.href);
  };

  return (
    <header>
      <Navbar
        id={isSticky ? "sticky" : ""}
        collapseOnSelect
        expand="lg"
        className={classNames("topnav-menu", navClass)}
      >
        <Container fluid={!fixedWidth}>
          <Navbar.Brand className="logo me-0">
            <NavLink to="/home">
              <img
                src={fourS_logo}
                className="align-top logo-dark top-menu-logo-lg"
                alt=""
              />
            </NavLink>
          </Navbar.Brand>

          <Navbar.Brand href={hkjc_link} target="_blank" className="logo me-0">
            <div className="px-3 top-menu-supp-text">捐助機構</div>
            <img
              src={hkjc_logo}
              className="align-top logo-dark top-menu-logo-sm"
              alt=""
            />
          </Navbar.Brand>

          <Navbar.Toggle
            className="me-3"
            aria-controls="topnav-menu-content4"
          />

          <Navbar.Collapse id="topnav-menu-content4">
            <Menu
              navClass="ms-auto"
              buttonClass={buttonClass ? buttonClass : "btn-primary"}
            />
            {!!isLogin ? (
              <Nav as="ul" className="align-items-lg-center">
                <ProfileDropdown profileOptions={profileOptions} />
              </Nav>
            ) : (
              <Nav>
                <div
                  onClick={handleLogin}
                  className="nav-link btn me-2 shadow-none"
                >
                  登入
                </div>
              </Nav>
            )}
              
                <div class="nav-link d-flex justify-content-center align-items-center flex-column changesizebox">
                  <input class="d-none" id="changesizecheckbox" type="checkbox"></input>
                  <label class="changesizebtn">
                      A
                  </label>
                  <div class="changesizelist">
                    <button data-size="1" class="fontsizebuttons fontsizebuttonssm">A-</button>
                    <button data-size="1.1" class="fontsizebuttons fontsizebuttonsmd">A</button>
                    <button data-size="1.2" class="fontsizebuttons fontsizebuttonslg">A+</button>
                  </div>
                </div>
              
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Navbar4;
